import { render, staticRenderFns } from "./chanchaoApp.vue?vue&type=template&id=48c57174&"
import script from "./chanchaoApp.vue?vue&type=script&lang=js&"
export * from "./chanchaoApp.vue?vue&type=script&lang=js&"
import style0 from "./chanchaoApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports